import { FileCheck, Lock, ShieldCheck } from "lucide-react";
import { Button } from "../ui/button";

type Props = {
  setShowDialog: (value: boolean) => void;
};

export function TakeControl({ setShowDialog }: Props) {
  return (
    <div className="relative isolate text-center">
      <p className="text-4xl lg:text-6xl font-bold tracking-tight">
        Ta kontroll över din digitala identitet.
      </p>
      <p className="text-4xl lg:text-6xl font-bold tracking-tight bg-linear-to-r from-cyan-500 via-cyan-400 to-cyan-600 inline-block text-transparent bg-clip-text text-wrap py-2">
        Hittar och tar bort dina exponerade personuppgifter.
      </p>
      <p className="text-muted-foreground py-6 max-w-2xl mx-auto">
        Baserat på offentliga register och datamäklare. GDPR-kompatibel.
      </p>

      <div className="flex justify-center">
        <Button variant="cta" size="cta" onClick={() => setShowDialog(true)}>
          Bli först att testa Echorai
        </Button>
      </div>

      <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mt-6 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-2">
          <ShieldCheck className="size-4 text-cyan-500" />
          BankID verifiering
        </span>
        <span className="inline-flex items-center gap-2">
          <Lock className="size-4 text-cyan-500" />
          EU-hosting • GDPR
        </span>
        <span className="inline-flex items-center gap-2">
          <FileCheck className="size-4 text-cyan-500" />
          PDF bevis
        </span>
      </div>

      <p className="text-muted-foreground text-xs pt-6">
        Ingen betalning krävs nu. Du blir kontaktad vid lansering.
      </p>
      <p className="text-muted-foreground text-xs pt-1">
        Tidig åtkomst ges till ett begränsat antal användare.
      </p>
    </div>
  );
}
